import React from "react";
import { motion } from "framer-motion";
import { useDashTheme } from "../hooks/useDashTheme";

// Switch. The inactive track uses a defined gray rather than surfaceMuted, which
// blends into cards, with an inset border so the pill still reads as a control.
// The thumb carries a hairline ring so white stays visible on any background.
export function Toggle({ on, onClick, disabled, label }) {
  const t = useDashTheme();
  const trackOff = t.isDark ? "#3A4055" : "#CBD2DE";
  return (
    <button
      onClick={onClick} role="switch" aria-checked={on} aria-label={label} disabled={disabled}
      style={{
        width: 42, height: 24, borderRadius: 99, border: "none", padding: 0, flexShrink: 0,
        cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.5 : 1,
        position: "relative", background: on ? t.c.primary : trackOff,
        boxShadow: on ? `0 0 0 1px ${t.c.primary}, 0 1px 3px ${t.c.glow}` : "inset 0 0 0 1px rgba(0,0,0,0.06)",
        transition: "background 180ms ease, box-shadow 180ms ease",
      }}
    >
      <motion.span
        animate={{ x: on ? 20 : 2 }} transition={t.motion.spring.snappy}
        style={{
          position: "absolute", top: 2, left: 0, width: 20, height: 20, borderRadius: 99, background: "#fff",
          boxShadow: "0 1px 2px rgba(16,24,40,0.28), 0 0 0 0.5px rgba(16,24,40,0.10)",
        }}
      />
    </button>
  );
}
